import React from 'react';
import { useState } from 'react'
// import products from '../data/computer'
import './BarCharts.css'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import 'bootstrap/dist/css/bootstrap.css';
import ExpirationGraph from './Graphic/ExpirationGraph';
import CreatedAtGraph from './Graphic/CreatedAtGraph'
import DemoGraph from './Graphic/DemoGraph'

export default function Graphic(props) {
    const products = props
    
    const [valor, setValue] = useState('1')

    const handleSelect = (e) => {
        setValue(e)
    }
    function pageControl() {
        if (valor === '1') {
            return (
                <div>
                    {ExpirationGraph(products)}
                </div>
            );
        } else if (valor === '2') {
            return (
                <div>
                    {CreatedAtGraph(products)}
                </div>
            );
        }else if (valor === '3') {
            return (
                <div>
                    {DemoGraph()}
                </div>
            );
        }
    }
    return (
        <div >
            <DropdownButton id="dropdown-item-button" title="Selecionar gráfico"
                onSelect={handleSelect} >
                <Dropdown.Item eventKey='1' as="button">Licenças que irão Expirar</Dropdown.Item>
                <Dropdown.Item eventKey='2' as="button">Licença criadas</Dropdown.Item>
                <Dropdown.Item eventKey='3' as="button">Demonstrações que irão Expirar</Dropdown.Item>
            </DropdownButton>
            {pageControl()}
        </div>
    );
}



